import { render, staticRenderFns } from "./c-include-exclude-report-sections.vue?vue&type=template&id=493cade0&scoped=true&"
import script from "./c-include-exclude-report-sections.vue?vue&type=script&lang=js&"
export * from "./c-include-exclude-report-sections.vue?vue&type=script&lang=js&"
import style0 from "./c-include-exclude-report-sections.vue?vue&type=style&index=0&id=493cade0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493cade0",
  null
  
)

export default component.exports